import { METERS_IN_MILE, METERS_IN_KM, METERS_IN_FOOT, SECONDS_IN_HOUR } from 'lib/units/constants'

export const getChallengeId = props => parseInt(props.match.params.challengeId, 10)

export const isEmpty = (goal, defaultName) => {
  return !goal.description && goal.name === defaultName
}

// int from server to user formatted
export const getFormattedValue = (value, goalType, metricUnits) => {
  if (goalType === 'distance') {
    return metricUnits
      ? value / METERS_IN_KM
      : value / METERS_IN_MILE
  }
  if (goalType === 'elevation_gain') {
    return metricUnits
      ? value
      : value / METERS_IN_FOOT
  }
  if (goalType === 'moving_time') {
    return value / SECONDS_IN_HOUR
  }
}

// user formatted to int for server
export const setFormattedValue = (value, goalType, metricUnits) => {
  if (goalType === 'distance') {
    return metricUnits
      ? value * METERS_IN_KM
      : value * METERS_IN_MILE
  }
  if (goalType === 'elevation_gain') {
    return metricUnits
      ? value
      : value * METERS_IN_FOOT
  }
  if (goalType === 'moving_time') {
    return value * SECONDS_IN_HOUR
  }
}
